import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { sendStat } from '../../hooks/sendStat';
import { callApi } from '../../utils/callApi';
import { TYPE_EVENT_VOTE } from '../../utils/consts';
import {
  GetCerteficate,
  TypeGetCerteficateR,
  TypeUpdateCerteficateR,
  TypeUpdateCerteficateProfileR,
  UpdateCerteficate,
  UpdateCerteficateProfile,
} from './actions';
import ActionTypes, { CertificateType, TCerteficateState, EntityType } from './types';

function* getCerteficateWorker(action: ReturnType<typeof GetCerteficate.request>): Generator {
  const { data, callBack } = action.payload as TypeGetCerteficateR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: '/api/ukd/getcert',
    })) as TCerteficateState['data'];
    yield put(GetCerteficate.success(resp));
  } catch (e) {
    success = false;
    yield put(GetCerteficate.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}
function* updateCerteficateWorker(action: ReturnType<typeof UpdateCerteficate.request>): Generator {
  const { data, callBack } = action.payload as TypeUpdateCerteficateR;

  let success = true;
  let resp = null;
  try {
    resp = (yield call(callApi, {
      method: 'post',
      data,
      path: '/api/ukd/updatecert',
    })) as EntityType;
    sendStat(TYPE_EVENT_VOTE);
    yield put(UpdateCerteficate.success(resp));
  } catch (e) {
    success = false;
    yield put(UpdateCerteficate.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success, resp);
  }
}

function* updateCerteficateProfileWorker(action: ReturnType<typeof UpdateCerteficateProfile.request>): Generator {
  const { data, callBack } = action.payload as TypeUpdateCerteficateProfileR;

  let success = true;
  let error = '';
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: '/api/ukd/profile',
    })) as CertificateType;

    yield put(UpdateCerteficateProfile.success(resp));
  } catch (e) {
    success = false;
    error = e as string;
    yield put(UpdateCerteficateProfile.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success, error);
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.UPDATE_CERTEFICATE_R, updateCerteficateWorker);
  yield takeEvery(ActionTypes.GET_CERTEFICATE_R, getCerteficateWorker);
  yield takeEvery(ActionTypes.UPDATE_CERTEFICATE_PROFILE_R, updateCerteficateProfileWorker);
}

export default function* certeficateSaga() {
  yield all([fork(watchRequest)]);
}
